import { createContext } from 'react'

export const HeaderVisibilityContext = createContext()
